import setPriceDuration from "@/store/modules/price/actions/setPriceDuration";
import setDuration from "@/store/modules/price/actions/setDuration";
import setVideo from "@/store/modules/price/actions/setVideo";
import setPriceThem from "@/store/modules/price/actions/setPriceThem";
import setPriceVideo from "@/store/modules/price/actions/setPriceVideo";
import setPriceMusic from "@/store/modules/price/actions/setPriceMusic";
import setDatePrice from "@/store/modules/price/actions/setDatePrice";
import setPricePrimeTime from "@/store/modules/price/actions/setPricePrimeTime";

export default {
    setPriceVideo,
    setDuration,
    setPriceDuration,
    setVideo,
    setPriceThem,
    setPriceMusic,
    setDatePrice,
    setPricePrimeTime,
    setMusic({ commit }, { music }) {
        commit('setMusic', { music })
    },
    async restPrice({commit}, { data }) {
        commit('restPrice', { data })
    },
    async setPrice({  dispatch  }) {
        await dispatch('setPriceVideo', null, {root: false })
        await dispatch('setPriceDuration', null, {root: false })
        await dispatch('setPriceThem', null, {root: false })
        await dispatch('setPriceMusic', null, {root: false })
        await dispatch('setDatePrice', null, {root: false })
        await dispatch('setPricePrimeTime', null, {root: false })
    },
    resetState({ commit }) {
        commit('resetState')
    }
}